import clsx from 'clsx'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import React, { PropsWithChildren, forwardRef } from 'react'
import styled from 'styled-components'
import _DropdownSheet, { DROPDOWN_SHEET_MAX_HEIGHT_CSS_VARIABLE, DROPDOWN_SHEET_MAX_WIDTH_CSS_VARIABLE, DROPDOWN_SHEET_MIN_WIDTH_CSS_VARIABLE, DROPDOWN_SHEET_WIDTH_CSS_VARIABLE } from '../_DropdownSheet'
import { readCSSVar, setCSSVar } from 'lib/theme/themeUtils'

const Container = styled(_DropdownSheet)`
  &:not(.auto-height) {
    ${setCSSVar(DROPDOWN_SHEET_MAX_HEIGHT_CSS_VARIABLE, rem(480))}

    ${mediaQueryUp.tablet} {
      ${setCSSVar(DROPDOWN_SHEET_MAX_HEIGHT_CSS_VARIABLE, rem(600))}
    }
  }

  &.size-S {
    ${setCSSVar(DROPDOWN_SHEET_MIN_WIDTH_CSS_VARIABLE, rem(200))}
    ${setCSSVar(DROPDOWN_SHEET_MAX_WIDTH_CSS_VARIABLE, rem(335))}

    ${mediaQueryUp.tablet} {
      ${setCSSVar(DROPDOWN_SHEET_MIN_WIDTH_CSS_VARIABLE, rem(220))}
      ${setCSSVar(DROPDOWN_SHEET_MAX_WIDTH_CSS_VARIABLE, rem(335))}
    }
  }
  &.size-M {
    ${setCSSVar(DROPDOWN_SHEET_MIN_WIDTH_CSS_VARIABLE, rem(335))}
    ${setCSSVar(DROPDOWN_SHEET_MAX_WIDTH_CSS_VARIABLE, rem(335))}

    ${mediaQueryUp.tablet} {
      ${setCSSVar(DROPDOWN_SHEET_MIN_WIDTH_CSS_VARIABLE, rem(400))}
      ${setCSSVar(DROPDOWN_SHEET_MAX_WIDTH_CSS_VARIABLE, rem(600))}
    }
  }
  &.size-fill-anchor {
    ${setCSSVar(DROPDOWN_SHEET_WIDTH_CSS_VARIABLE, '100%')}
  }

  &:not(.size-fill-anchor) {
    &.width-auto {
      ${setCSSVar(DROPDOWN_SHEET_WIDTH_CSS_VARIABLE, 'auto')}
    }
    &.width-min {
      ${setCSSVar(DROPDOWN_SHEET_WIDTH_CSS_VARIABLE, readCSSVar(DROPDOWN_SHEET_MIN_WIDTH_CSS_VARIABLE))}
      ${setCSSVar(DROPDOWN_SHEET_MAX_WIDTH_CSS_VARIABLE, readCSSVar(DROPDOWN_SHEET_MIN_WIDTH_CSS_VARIABLE))}
    }
    &.width-max {
      ${setCSSVar(DROPDOWN_SHEET_WIDTH_CSS_VARIABLE, readCSSVar(DROPDOWN_SHEET_MAX_WIDTH_CSS_VARIABLE))}
      ${setCSSVar(DROPDOWN_SHEET_MIN_WIDTH_CSS_VARIABLE, readCSSVar(DROPDOWN_SHEET_MAX_WIDTH_CSS_VARIABLE))}
    }
  }
`

interface Props extends PropsWithChildren {
  /**
   * Controls the width and height of the sheet
   */
  size: 'S' | 'M' | 'fill-anchor'
  /**
   * If set to min or max, the width of the sheet will be set to the specified boundary explicitly,
   * otherwise, the width will be clamped between the boundaries.
   *
   * _NOTE:_ This does not affect anything if the `size` is set to `fill-anchor`.
   *
   * @default auto
   */
  width?: 'auto' | 'min' | 'max'
  autoHeight?: boolean
}

const DropdownListSheet = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const {
    children,
    size,
    width = 'auto',
    autoHeight,
  } = props

  return <Container ref={ref} className={clsx(`size-${size}`, `width-${width}`, { 'auto-height': autoHeight })}>
    {children}
  </Container>
})

export default DropdownListSheet
